"use client";

import { Award, Download, Shield, Sparkles, Syringe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliancecertifications() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const standards = [{
    icon: Shield,
    title: "Confidentiality Protocols",
    description: "We maintain rigorous data security and non-disclosure standards to protect your proprietary information throughout the entire M&A lifecycle."
  }, {
    icon: Syringe,
    title: "Regulatory Compliance",
    description: "Our firm adheres to strict SEC and FINRA regulatory frameworks, ensuring all transactions meet the highest legal and ethical standards."
  }, {
    icon: Sparkles,
    title: "Valuation Integrity",
    description: "We utilize data-driven, transparent valuation models to ensure accurate market positioning and maximum value realization for your business."
  }, {
    icon: Award,
    title: "Fiduciary Responsibility",
    description: "As your strategic partner, we prioritize your long-term legacy and financial objectives above all else, acting with complete transparency."
  }];
  const certifications = ["SEC REGISTERED", "FINRA COMPLIANT", "M&A ADVISORY STANDARDS", "DATA PRIVACY CERTIFIED", "GLOBAL INVESTMENT ALLIANCE"];
  return;
}